import React, { useEffect, useLayoutEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { setLoading } from "../../../redux/loading/loadingSlice";
import { useDispatch, useSelector } from "react-redux";
import { storeUser, updateUser } from "../../../redux/users/usersSlice";
import useApi from "../../../helpers/apiHelper/requestHelper";
import { toastify } from "../../../helpers/toast/toastify";
import RenderLinks from "../../../components/links/RenderLinks";
import DeleteMember from "../../../components/modals/DeleteMember";
import SubscriptionConfirmModal from "./SubscriptionConfirmModal";
import copyIcon from "../../../assets/images/Copy.svg";
import { setShowConnectionSuccessModal } from "../../../redux/loading/loadingSlice";
import { userCommunity } from "../../../redux/community/communitySlice";
import successGif from "../../../assets/images/success.gif";
import errorGif from "../../../assets/images/error.gif";
import paymentOptions from "../../../assets/images/payment-options.svg";
import BubbleSvgButton from "../CommonComponents/BubbleSvgButton/BubbleSvgButton";
import { getMemberCommunityDisplayName } from "../../../helpers/memberCommunityDisplay";
import stripe from "../../../assets/images/verifyTrades/stripeIcon.svg";
import threeD from "../../../assets/images/3d-secure.png";
import masterCard from "../../../assets/images/MasterCardIcon.svg";
import visa from "../../../assets/images/VisaVerified.png";
import infoIcon from "../../../assets/images/teir-info-icon.png";
import "bootstrap-icons/font/bootstrap-icons.css";
import SubscriptionPaymentPlanMember from "./subscritionPaymentPlanMember";
import VipVerificationPopUp from "../VipScreen/VipVerificationPopUp";
import moment from "moment";
import BillingHistory from "./BillingHistory";
import { isBrowser } from "react-device-detect";
import LoadingOverlay from "../LoadingOverlay";
import "./subscribe.css";
// import "../NewCopyTrade/ExchangeConnection/ExchangeConnection.css"; // now loaded via SubscriptionConfirmModal
import PaymentSuccessModal from "../PaymentSuccessModal";
import VerifyTradeHistory from "../../VerifyMyTrade/VerifiedPaymentBillingHistory/VerifyTradeHistory";
import SubscriptionFooter from "../../VerifyMyTrade/VerifiedPaymentBillingHistory/VerifiedPaymentSubscriptionPlan/SubscriptionFooter";

// New Pricing Component with inline styles
const NewPricingComponent = ({
  activeTab,
  handleTabChange,
  user,
  subscription,
  fullcommunity,
  vipSubscription,
  isVipSubscriptionSubscribed,
  anySubscriptionSubscribe,
  selectedPlan,
  setSelectedPlan,
  planSub,
  checkedIndex,
  setCheckIndex,
  vipCheckBoxClick,
  setVipCheckBoxCLick,
  vipButtonText,
  handleCheckout,
  handleCancelModal,
  setShowModal,
  setSelectedCommunity,
  setShowVipPopUp,
  setCommunity,
  dispatch,
  userCommunity,
  setSubIs,
  setfullCommunity,
  additionalFee,
  navigate,
}) => {
  const isPlanSubscribed = (community, planType) => {
    const subscribedPlan =
      community?.subscribedPlan || community?.cryptoSubscription;
    const subscriptionId = community?.subscription;

    const matchingSubscription = community?.community?.subscription?.find(
      (subscription) => subscription._id === subscriptionId,
    );

    return (
      community?.subscribed &&
      subscribedPlan &&
      matchingSubscription &&
      (matchingSubscription[`${planType}PlanId`] === subscribedPlan ||
        (community?.cryptoSubscription && community?.planType === planType))
    );
  };

  const getNextMonthSameDate = (date, planType) => {
    const newDate = new Date(date);
    if (planType === "yearly") {
      newDate.setFullYear(newDate.getFullYear() + 1);
    } else {
      newDate.setMonth(newDate.getMonth() + 1);
    }
    return newDate;
  };
  const isCancelMode = vipCheckBoxClick[activeTab]
  ? isVipSubscriptionSubscribed?.[activeTab]
  : selectedPlan &&
    planSub &&
    activeTab === fullcommunity?.planType &&
    (fullcommunity?.subscribedPlan === selectedPlan?.yearlyPlanId ||
      fullcommunity?.subscribedPlan ===
        selectedPlan?.monthlyPlanId);
  const handlePlanSelect = (plan, index, community) => {
    const subscribed = isPlanSubscribed(community, activeTab);
    const yearlySubscribed = isPlanSubscribed(
      community,
      activeTab === "monthly" ? "yearly" : "monthly",
    );

    if (subscribed || yearlySubscribed) return;

    setSelectedPlan(plan);
    setCheckIndex(index);
    setfullCommunity(community);
    setVipCheckBoxCLick({ monthly: false, yearly: false });
    setSubIs(plan._id);

    if (dispatch && userCommunity) {
      dispatch(
        userCommunity({
          subscription: plan,
          communityId: community?.community?._id,
          plan: activeTab,
        }),
      );
    }
  };

  const handleVipSelect = () => {
    if (anySubscriptionSubscribe) return;
    setCheckIndex(null);
    setSelectedPlan(null);
    setVipCheckBoxCLick({
      monthly: activeTab === "monthly",
      yearly: activeTab === "yearly",
    });
  };

  const handlePaymentClick = () => {
    if (!fullcommunity) return;

    const subscribed = isPlanSubscribed(fullcommunity, activeTab);
    const yearlySubscribed = isPlanSubscribed(
      fullcommunity,
      activeTab === "monthly" ? "yearly" : "monthly",
    );

    const myPlanSubscribed =
      fullcommunity?.subscribedPlan === selectedPlan?.yearlyPlanId ||
      fullcommunity?.subscribedPlan === selectedPlan?.monthlyPlanId;

    const isSamePlanType = activeTab === fullcommunity.planType;

    if (planSub && isSamePlanType && myPlanSubscribed) {
      setSelectedCommunity(fullcommunity);
      setShowModal(true);
    } else if (subscribed || yearlySubscribed) {
      handleCancelModal?.();
    } else {
      handleCheckout?.(fullcommunity, checkedIndex, activeTab);
    }
  };

  const handleVipPayment = () => {
    if (isVipSubscriptionSubscribed?.[activeTab]) {
      setSelectedCommunity(fullcommunity);
      setShowModal(true);
    } else {
      setShowVipPopUp?.({ show: true });
      setCommunity?.({
        communityId: user?.memberCommunities?.[0]?.community?._id,
        subscription: vipSubscription,
        plan: activeTab,
      });
    }
  };

  const getButtonText = () => {
    if (!fullcommunity || !selectedPlan) return "Select a plan";

    const myPlanSubscribed =
      fullcommunity?.subscribedPlan === selectedPlan?.yearlyPlanId ||
      fullcommunity?.subscribedPlan === selectedPlan?.monthlyPlanId;

    const isSamePlanType = activeTab === fullcommunity.planType;
    const subscribed = isPlanSubscribed(fullcommunity, activeTab);
    const yearlySubscribed = isPlanSubscribed(
      fullcommunity,
      activeTab === "monthly" ? "yearly" : "monthly",
    );

    if (planSub && isSamePlanType && myPlanSubscribed) {
      return "Cancel";
    } else if (subscribed || yearlySubscribed) {
      return "Upgrade";
    } else {
      const price =
        Number(
          selectedPlan[activeTab === "monthly" ? "monthlyfee" : "yearlyfee"],
        ) + additionalFee;
      return `Subscribe for $${price} / ${activeTab === "monthly" ? "month" : "year"}`;
    }
  };

  const getNextBillingDate = () => {
    if (planSub) {
      return moment(user?.memberCommunities[0]?.subscriptionExpiry).format(
        "MM/DD/YYYY",
      );
    }
    return moment(getNextMonthSameDate(new Date(), activeTab)).format(
      "MM/DD/YYYY",
    );
  };


  // Generate plans from subscription data
  const generatePlans = () => {
    if (!subscription?.length) return [];

    const community = user?.memberCommunities?.[0];

    return subscription.map((subs, index) => {
      const subscribed = isPlanSubscribed(community, activeTab);
      const yearlySubscribed = isPlanSubscribed(
        community,
        activeTab === "monthly" ? "yearly" : "monthly",
      );

      const isSelected = checkedIndex === index && !vipCheckBoxClick[activeTab];
      const isDisabled = subscribed || yearlySubscribed;
      const price =
        Number(subs[activeTab === "monthly" ? "monthlyfee" : "yearlyfee"]) +
        additionalFee;

      return {
        id: subs._id,
        price: `$${price}`,
        period: activeTab === "monthly" ? "month" : "year",
        maxTrade:
          subs.tradingCapital?.toString().toUpperCase() === "UNLIMITED"
            ? "Unlimited"
            : `$${(subs.tradingCapital || 0).toLocaleString()}`,
        description: "Group usually use 1-5% of this is use / trade",
        originalData: subs,
        index,
        isSelected,
        isDisabled,
      };
    });
  };

  // const allPlans = generatePlans();
  // // Add VIP plan if available
  // if (vipSubscription) {
  //   const isVipSelected = vipCheckBoxClick[activeTab];
  //   const vipPrice = activeTab === "monthly" ? 15 : 180;
  //   allPlans.push({
  //     id: "vip", price: `$${vipPrice}`, period: activeTab === "monthly" ? "month" : "year",
  //     maxTrade: "VIP", description: "VIP subscription", isVip: true,
  //     isSelected: isVipSelected, isDisabled: false,
  //   });
  // }

  // const showText = { monthly: "month", yearly: "year" };

  return (
    <>
      <div>
        {/* Billing Toggle */}
        <div className="my-grid-dropdown">
          <button
            className={activeTab === "monthly" ? "active" : ""}
            onClick={() => handleTabChange("monthly")}
          >
            Monthly
          </button>
          <button
            className={activeTab === "yearly" ? "active" : ""}
            onClick={() => {
              handleTabChange("yearly");
              
            }}
          >
            Yearly
          </button>
        </div>

        {/* OLD: my-grid card rendering replaced by SubscriptionPaymentPlanMember */}
        {/* <div className="my-grid">
          {allPlans.map((plan) => { ... })}
        </div>
        {!allPlans.length && <p>Join Community to Subscribe!</p>} */}

        {/* NEW: member plan cards with per-card subscribe/cancel buttons */}
        <SubscriptionPaymentPlanMember
          activeTab={activeTab}
          additionalFee={additionalFee}
          subscriptions={subscription}
          vipSubscription={vipSubscription}
          onSubscribe={(plan, planType) => {
            setCommunity({
              communityId: user?.memberCommunities?.[0]?.community?._id,
              subscription: plan,
              plan: planType,
            });
            navigate("/member/stripePaymentScreen");
          }}
          onCancel={() => {
            setSelectedCommunity(fullcommunity);
            setShowModal(true);
          }}
        />

        {/* <div className="my-grid-trial-period">
          7d Free Trial. Cancel or upgrade subscription anytime. Auto-renews{" "}
          {activeTab}. <p className="fw-medium">Next billing date: {getNextBillingDate()}</p>
        </div> */}

        {/* OLD: single external pay button — each card now has its own button */}
        {/* <div className="pay-button-centenr">
          <BubbleSvgButton
            text={vipCheckBoxClick[activeTab] ? vipButtonText[activeTab] : getButtonText()}
            variant={isCancelMode ? "red" : "black"}
            onClick={() => { if (vipCheckBoxClick[activeTab]) { handleVipPayment(); } else if (selectedPlan) { handlePaymentClick(); } }}
            disabled={!vipCheckBoxClick[activeTab] && !selectedPlan}
            mainDivStyle={{ width: "275px", height: "55px" }}
          />
        </div> */}

        {/* Payment Info */}
      </div>
      <SubscriptionFooter variant="member" />
    </>
  );
};

function Subscribe({ setCommunity }) {
  const [activeTab, setActiveTab] = useState("monthly");
  const [selectedCommunity, setSelectedCommunity] = useState();
  const [paymentInfo, setPaymentInfo] = useState();
  const [showModal, setShowModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [paymentSuccessView, setPaymentSuccessView] = useState(false);
  const [paymentFailView, setPaymentFailView] = useState(false);
  const [planSub, setPlanSub] = useState(false);
  const [notShowPaymentDetail, setNotShowPaymentDetail] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState({});
  const [subId, setSubIs] = useState("");

  const [fullcommunity, setfullCommunity] = useState("");
  const [subscription, setSubscription] = useState([]);
  const [checkedIndex, setCheckIndex] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const api = useApi();
  const user = useSelector((state) => state?.user?.user);
  const { id } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const sessionId = searchParams.get("session_id");
  const [tradingCapitalInfoIndex, setTradingCapitalInfoIndex] = useState(false);
  const [vipSubscription, setVipSubscription] = useState(null);
  const [isVipSubscriptionSubscribed, setIsVipSubscriptionSubscribed] =
    useState({ monthly: false, yearly: false });
  const [vipCheckBoxClick, setVipCheckBoxCLick] = useState({
    monthly: false,
    yearly: false,
  });
  const [displayOverlay, setDisplayOverlay] = useState(false);
  const [showVipPopUp, setShowVipPopUp] = useState({
    show: false,
  });
  const [anySubscriptionSubscribe, setAnySubscriptionSubscribe] =
    useState(false);
  const [vipButtonText, setVipButtonText] = useState({
    monthly: "Subscribe for $15 / month",
    yearly: "Subscribe for $180 / yearly",
  });

  const additionalFee = activeTab === "monthly" ? 15 : 180;

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    // if (!planSub) {
    //   setCheckIndex(0);
    // }
  };

  useEffect(() => {
    if (user?.memberCommunities?.length) {
      for (let index = 0; index < user?.memberCommunities?.length; index++) {
        const element = user?.memberCommunities[index];
        if (element?.cryptoPayAddress && !element?.subscribed) {
          setPaymentInfo({
            id: element?.cryptoPaymentId,
            communityId: element?.community?._id,
            address: element?.cryptoPayAddress,
            subscriptionId: element?.subscription,
            interval: element?.planType,
            price: element?.paidAmount,
            payableAmount: element?.cryptoPayableAmount,
          });

          break;
        }
      }
    }
  }, [user?.memberCommunities]);

  const fetchUserData = async () => {
    const response = await api("get", "users/index");
    if (response?.status) {
      dispatch(storeUser(response?.data));
      localStorage.setItem("token", response?.data?.token);
    }
  };

  // const unsubscribeCrypto = async () => {
  //   let communityId = selectedCommunity?.community?._id;
  //   dispatch(setLoading(true));
  //   // localStorage.setItem('customerId', true);
  //   let response = await api("post", "users/unsubCrypto", { communityId });
  //   if (response?.status) {
  //     setPlanSub(false);
  //     setShowModal(false);
  //     setActiveTab(response?.data?.user?.memberCommunities[0]?.planType);
  //     await fetchUserData();
  //   } else {
  //     toastify("Unable to unsubscribe");
  //   }
  //   dispatch(setLoading(false));
  // };

  const cancelPayment = async () => {
    dispatch(setLoading(true));
    // localStorage.setItem('customerId', 'undefined');
    let response = await api("post", "users/cancelCryptoPayment", {
      communityId: paymentInfo?.communityId,
    });

    if (response?.status) {
      await fetchUserData();
      toastify("Crypto payment cancelled successfully.", "success");
      setPaymentInfo();
    } else {
      toastify("Unable to cancel crypto payment");
    }
    dispatch(setLoading(false));
  };

  const checkStatus = async () => {
    dispatch(setLoading(true));
    let response = await api("post", "users/checkCryptoStatus", {
      paymentId: paymentInfo?.id,
    });

    if (response?.data?.payment_status) {
      let status = response?.data?.payment_status;
      if (status === "failed") {
        setPaymentInfo();
        await cancelPayment();
        toastify("Payment has been failed. Please try again later.");
      } else if (status === "finished") {
        let { interval, price, communityId, subscriptionId } = paymentInfo;
        let subscribe = await api("post", "users/createCryptoSubscription", {
          communityId,
          amount: price,
          interval,
          subscriptionId,
        });
        if (subscribe?.status) {
          setPlanSub(true);
          await fetchUserData();
          setPaymentInfo();
          toastify("Payment confirmed successfully.", "success");
          const responseUser = await api("post", "users/update", {
            ...(user?.firstVisit ? { onboard: "done" } : {}), // Add onboard: "done" only if user.firstVisit is true
            // firstVisit: false,
            onboarding: { ...user.onboarding, payment: true },
            onboardingStep: "",
          });
          if (!responseUser?.data.user?.firstVisit) {
            dispatch(setShowConnectionSuccessModal(true));
            dispatch(setLoading(false));
            setPaymentSuccessView(true);
            setTimeout(() => {
              dispatch(setShowConnectionSuccessModal(false));
              navigate("/member/tradeActive", { replace: true });
            }, 2000);
          }
        } else {
          toastify(`Unable to subscribe you for ${activeTab} subscription.`);
        }
      } else {
        toastify(`Payment status is ${status}. Please try again later.`);
        dispatch(setLoading(false));
        setPaymentFailView(true);
      }
    }
    dispatch(setLoading(false));
  };

  const createSubscription = async () => {
    try {
      dispatch(setLoading(true));
      setDisplayOverlay(true);
      const response = await api("post", "users/handlePayments", {
        sessionId: sessionId,
        communityId: id,
      });
      if (response?.status) {
        setPaymentSuccessView(true);
        setDisplayOverlay(false);
        dispatch(updateUser(response?.data?.user));
        // dispatch(setLoading(false));
        setPlanSub(true);
        dispatch(setShowConnectionSuccessModal(true));
        const responseUser = await api("post", "users/update", {
          ...(user?.firstVisit ? { onboard: "done" } : {}), // Add onboard: "done" only if user.firstVisit is true
          // firstVisit: false,
          onboarding: { ...user.onboarding, payment: true },
        });
        setActiveTab(responseUser?.data?.user?.memberCommunities[0]?.planType);
        dispatch(updateUser(responseUser?.data?.user));
        dispatch(setLoading(false));
        if (responseUser?.data.user?.firstVisit) {
          setTimeout(() => {
            // setPaymentSuccessView(false)
            dispatch(setShowConnectionSuccessModal(false));
            navigate("/member/tradeActive", { replace: true });
          }, 2000);
        } else {
          setTimeout(() => {
            setPaymentSuccessView(false);
            setNotShowPaymentDetail(false);
            navigate("/member/copyTrade", { replace: true });
          }, 2000);
        }
        toastify("You have been subscribed successfully.", "success");
      } else {
        // toastify(response?.message);
        dispatch(setLoading(false));
        setPaymentFailView(true);
      }
    } catch (err) {
      console.log(err);
      // toastify("Payment Unsuccessful");
    }
  };

  useEffect(() => {
    // dispatch(updateUser(user))
    if (id) {
      createSubscription();
      // setDisplayOverlay(false);
    }
    dispatch(setLoading(false));

    if (user?.memberCommunities[0]?.subscribed) {
      setActiveTab(user?.memberCommunities[0]?.planType);
    }
  }, []);

  useLayoutEffect(() => {
    if (id) {
      setNotShowPaymentDetail(true);
    }
  }, []);

  useEffect(() => {
    const allSubscription =
      user?.memberCommunities?.[0]?.community?.subscription || [];

    const anySubcriped = user?.memberCommunities?.[0]?.subscribed;
    const vipSubscription = allSubscription.filter(
      (sub) => sub.name.endsWith("_Vip") && sub.isAllowed,
    )[0];

    const isVipSubscriped =
      vipSubscription?._id === user?.memberCommunities?.[0]?.subscription &&
      anySubcriped;

    const planType = user?.memberCommunities?.[0]?.planType;

    setAnySubscriptionSubscribe(anySubcriped);

    if (isVipSubscriped && planType === "monthly") {
      setVipButtonText({
        monthly: "Cancel",
        yearly: "Upgrade",
      });
      setVipCheckBoxCLick({ monthly: true, yearly: false });
      setIsVipSubscriptionSubscribed({
        monthly: true,
        yearly: false,
      });
    } else if (isVipSubscriped && planType === "yearly") {
      setVipButtonText({
        monthly: "Upgrade",
        yearly: "Cancel",
      });
      setVipCheckBoxCLick({ monthly: false, yearly: true });
      setIsVipSubscriptionSubscribed({
        monthly: false,
        yearly: true,
      });
    } else if (user?.memberCommunities?.[0]?.subscribed) {
      setVipButtonText({
        monthly: "Upgrade",
        yearly: "Upgrade",
      });
      setVipCheckBoxCLick({ monthly: false, yearly: false });
      setIsVipSubscriptionSubscribed({
        monthly: false,
        yearly: false,
      });
    } else {
      setVipCheckBoxCLick({
        monthly: "Pay $15",
        yearly: "Pay $180",
      });
      setVipCheckBoxCLick({ monthly: false, yearly: false });
      setIsVipSubscriptionSubscribed({
        monthly: false,
        yearly: false,
      });
      setVipButtonText({
        monthly: "Subscribe for $15 / month",
        yearly: "Subscribe for $180 / yearly",
      });
    }

    setVipSubscription(vipSubscription);
  }, [user?.memberCommunities]);

  useEffect(() => {
    user?.memberCommunities?.forEach((com) => {
      let subscriptionId = com?.subscription;
      if (com?.subscribed) {
        setSelectedPlan(subscriptionId);
        setfullCommunity(com);

        setPlanSub(true);
      } else {
        setfullCommunity(com);
      }

      return com?.community?.subscription?.find((s, i) => {
        if (s?._id === subscriptionId) {
          if (com.subscribed) {
            setCheckIndex(i);
          } else {
            setCheckIndex(0);
          }
        }
      });
    });

    const allSubscription =
      user?.memberCommunities?.[0]?.community?.subscription || [];

    const vipSubscription = allSubscription.filter(
      (sub) => sub.name.endsWith("_Vip") && sub.isAllowed,
    )[0];

    if (user?.memberCommunities) {
      const allSubscriptions = user?.memberCommunities?.flatMap((com) => {
        return (
          com?.community?.subscription?.filter((subscription) => {
            if (subscription?.name?.endsWith("_Vip")) return false;
    
            if (subscription?.isActive === true) return true;
    
            // Only surface a non-active tier when the member is still subscribed
            // (e.g. leader turned tier off). Stale subscription ids after cancel must not appear.
            if (
              com?.subscribed &&
              subscription?._id === com?.subscription &&
              vipSubscription?._id !== com?.subscription &&
              com?.planType === activeTab
            ) {
              return true;
            }
    
            return false;
          }) || []
        );
      });
      allSubscriptions.sort((a, b) => Number(a.monthlyfee) - Number(b.monthlyfee));
      setSubscription(allSubscriptions);

      if (user?.memberCommunities[0]?.subscribed) {
        const ind = allSubscriptions.findIndex(
          (s) => s?._id === user?.memberCommunities[0]?.subscription,
        );
        if (ind !== -1) {
          setSelectedPlan(allSubscriptions[ind]);
          setCheckIndex(ind);
        } else {
          setSelectedPlan(allSubscriptions[3]);
          setCheckIndex(3);
        }
      } else {
        if (allSubscriptions && allSubscriptions?.length > 0) {
          setSelectedPlan(allSubscriptions[0]);
          if (!user?.memberCommunities[0]?.subscribed) {
            setSubIs(allSubscriptions[0]?._id || 0);
          }
        }
      }
    }
  }, [user?.memberCommunities, activeTab]);

  const handleCheckout = async (com, subscriptionIndex, plan) => {
    setCommunity({
      communityId: com?.community?._id,
      subscription: com?.community?.subscription.find((s) => s._id === subId),
      plan,
    });

    navigate("/member/stripePaymentScreen");
  };

  // const yesAction = async () => {
  //   dispatch(setLoading(true));
  //   setShowModal(false);
  //   setShowCancelModal(false);
  //   const response = await api("post", "users/unsubscribe", {
  //     sessionId: selectedCommunity?.sessionId,
  //     communityId: selectedCommunity?.community?._id,
  //     userId: user._id,
  //   });
  //   if (response?.status) {
  //     // setActiveTab("monthly")
  //     // toastify("You have been unsubscribed successfully!", "success");
  //     setPlanSub(0);
  //     setCheckIndex(0);
  //     dispatch(updateUser(response?.data?.user));
  //     dispatch(userCommunity({ subscription: subscription[0], communityId: selectedCommunity?.community?._id, plan: activeTab }));
  //   } else {
  //     toastify(response?.message);
  //   }
  //   dispatch(setLoading(false));
  // };

  const noAction = () => {
    setShowModal(false);
  };

  const handleSubscriptionCancelConfirm = async () => {
    setCancelLoading(true);
    if (selectedCommunity?.cryptoSubscription) {
      const communityId = selectedCommunity?.community?._id;
      const response = await api("post", "users/unsubCrypto", { communityId });
      if (response?.status) {
        setPlanSub(false);
        setActiveTab(response?.data?.user?.memberCommunities[0]?.planType);
        await fetchUserData();
      } else {
        toastify("Unable to unsubscribe");
      }
    } else {
      const response = await api("post", "users/unsubscribe", {
        sessionId: selectedCommunity?.sessionId,
        communityId: selectedCommunity?.community?._id,
        userId: user._id,
      });
      if (response?.status) {
        setPlanSub(0);
        setCheckIndex(0);
        dispatch(updateUser(response?.data?.user));
        dispatch(
          userCommunity({
            subscription: subscription[0],
            communityId: selectedCommunity?.community?._id,
            plan: activeTab,
          }),
        );
      } else {
        toastify(response?.message);
      }
    }
    setCancelLoading(false);
    setShowModal(false);
  };

  const noActionPayment = () => {
    setShowCancelModal(false);
  };

  const isPlanSubscribed = (com, planType) => {
    const subscribedPlan = com?.subscribedPlan || com?.cryptoSubscription;
    const subscriptionId = com?.subscription;

    const matchingSubscription = com?.community?.subscription?.find(
      (subscription) => subscription._id === subscriptionId,
    );

    return (
      com?.subscribed &&
      subscribedPlan &&
      matchingSubscription &&
      (matchingSubscription[`${planType}PlanId`] === subscribedPlan ||
        (com?.cryptoSubscription && com?.planType === planType))
    );
  };

  const handlePaymentFailView = async () => {
    // setPaymentFailView(false)
    // setNotShowPaymentDetail(true)
    // navigate('/member/copyTrade');
    const responseUser = await api("post", "users/update");
    setActiveTab(responseUser?.data?.user?.memberCommunities[0]?.planType);
    setTimeout(() => {
      setPaymentFailView(false);
      setNotShowPaymentDetail(false);
      navigate("/member/copyTrade", { replace: true });
    }, 0);
  };

  function getNextMonthSameDate(date, activeTab) {
    const currentDate = new Date(date);
    if (activeTab === "monthly") {
      currentDate.setMonth(currentDate.getMonth() + 1);
    } else if (activeTab === "yearly") {
      currentDate.setFullYear(currentDate.getFullYear() + 1);
    }
    return currentDate;
  }

  const handleCancelModal = () => {
    setShowCancelModal(true);
  };

  return (
    <>
      {!displayOverlay && (
        <React.Fragment>
          {paymentSuccessView ? (
            <PaymentSuccessModal />
          ) : paymentFailView ? (
            <div className="connectLoader">
              <div className="text-center">
                <h3 className="fs20 li_h30 bold">
                  Oops. Something went wrong : &#40;
                </h3>
                <p className="fs14 mb-26">Please try again</p>
                <img src={errorGif} alt="loaderGif" height={248} /> <br />
                <button
                  style={{ width: "294px" }}
                  className="newCreateButton"
                  onClick={() => {
                    handlePaymentFailView();
                  }}
                >
                  Try again
                </button>
              </div>
            </div>
          ) : (
            !notShowPaymentDetail && (
              <>
                {user?.firstVisit && (
                  <div className="text-center">
                    {getMemberCommunityDisplayName(user) ? (
                      <p className="fs16 bold mb-21 text-center">
                        {getMemberCommunityDisplayName(user)?.toUpperCase()}
                      </p>
                    ) : (
                      <span className="mb-27 text-light">.</span>
                    )}
                  </div>
                )}

                {/* REPLACED SUBSCRIPTION SECTION WITH NEW DESIGN */}
                {/* pricing */}
                <div className="p-lg-0">
                  {/* <div className="d-flex align-items-center justify-content-start">
                <div className="title w-100">
                  <h3 className="text-xl-start text-md-start text-center font-bold mb-6">
                    Your subscription
                  </h3>
                </div>
              </div> */}

                  {paymentInfo ? (
                    <>
                      <h1 className="fs14 bold mt-2">
                        Please make payment at the following Pay Address ({" "}
                        {paymentInfo?.payableAmount} USDT TRC20)
                      </h1>
                      <div className="url p-0">
                        <div className="position-relative d-flex align-items-center justify-content-end copyBlock mt-2">
                          <input
                            type="text"
                            className="form-control fs15"
                            value={paymentInfo?.address}
                            disabled
                          />
                          <span className="position-absolute me-2">
                            <img
                              className="cursor-pointer me-2"
                              onClick={() => {
                                const payAddress = paymentInfo?.address;

                                navigator.clipboard
                                  .writeText(payAddress)
                                  .then(() => {
                                    toastify(
                                      "Pay Address copied to clipboard!",
                                      "success",
                                    );
                                  })
                                  .catch((error) => {
                                    console.error(
                                      "Clipboard write error:",
                                      error,
                                    );
                                    toastify(
                                      "Failed to copy community link to clipboard.",
                                      "error",
                                    );
                                  });
                              }}
                              alt="copyIcon"
                              src={copyIcon}
                            />
                          </span>
                        </div>
                      </div>

                      <div className="d-flex w-100">
                        <div className="ml-auto">
                          <button className="black-btn" onClick={cancelPayment}>
                            Cancel Payment
                          </button>
                          <button
                            className="black-btn ml-20"
                            onClick={checkStatus}
                          >
                            Verify Payment
                          </button>
                        </div>
                      </div>
                    </>
                  ) : (
                    <NewPricingComponent
                      activeTab={activeTab}
                      handleTabChange={handleTabChange}
                      user={user}
                      subscription={subscription}
                      fullcommunity={fullcommunity}
                      vipSubscription={vipSubscription}
                      isVipSubscriptionSubscribed={isVipSubscriptionSubscribed}
                      anySubscriptionSubscribe={anySubscriptionSubscribe}
                      selectedPlan={selectedPlan}
                      setSelectedPlan={setSelectedPlan}
                      planSub={planSub}
                      checkedIndex={checkedIndex}
                      setCheckIndex={setCheckIndex}
                      vipCheckBoxClick={vipCheckBoxClick}
                      setVipCheckBoxCLick={setVipCheckBoxCLick}
                      vipButtonText={vipButtonText}
                      handleCheckout={handleCheckout}
                      handleCancelModal={handleCancelModal}
                      setShowModal={setShowModal}
                      setSelectedCommunity={setSelectedCommunity}
                      setShowVipPopUp={setShowVipPopUp}
                      setCommunity={setCommunity}
                      dispatch={dispatch}
                      userCommunity={userCommunity}
                      setSubIs={setSubIs}
                      setfullCommunity={setfullCommunity}
                      additionalFee={additionalFee}
                      navigate={navigate}
                    />
                  )}
                </div>
              </>
            )
          )}
          {!user?.firstVisit && (
            <>
              {/* <BillingHistory notShowPaymentDetail={notShowPaymentDetail} /> */}
              <VerifyTradeHistory />
            </>
          )}

          <SubscriptionConfirmModal
            show={showModal}
            onClose={noAction}
            title="You're about to cancel your subscription"
            subtext="If you cancel subscription your copy trade will stop working by the end of the subscription period. Please note that there's no refunds if you choose to upgrade your subscription. Do you still want to cancel?"
            confirmText="Yes"
            // onConfirm={() => { selectedCommunity?.cryptoSubscription ? unsubscribeCrypto() : yesAction(); }}
            onConfirm={handleSubscriptionCancelConfirm}
            cancelText="No"
            onCancel={noAction}
            isLoading={cancelLoading}
          />
          {showVipPopUp?.show && (
            <VipVerificationPopUp
              setShowVipPopUp={setShowVipPopUp}
              callApi={() => {
                navigate("/member/stripePaymentScreen");
              }}
            />
          )}
          <RenderLinks page="copyTradePayment" />

          <SubscriptionConfirmModal
            show={showCancelModal}
            onClose={noActionPayment}
            title="You're already subscribed"
            subtext="Please cancel current subscription to subscribe to your preferred subscription plan."
            confirmText="Ok"
            onConfirm={noActionPayment}
            showCancel={false}
          />
        </React.Fragment>
      )}
      {displayOverlay && <LoadingOverlay />}
    </>
  );
}

export default Subscribe;
